"use client";

import { createContext, type ReactNode, useContext } from "react";
import type { AppAuthUser } from "@/types";

// Passes the layout-resolved user down so client components (welcome text,
// settings rows, ...) don't need to await getAppAuth themselves — which would
// re-trigger Suspense on every navigation in production.
const AuthUserContext = createContext<AppAuthUser | null>(null);

export function AuthUserProvider({
  user,
  children,
}: {
  user: AppAuthUser;
  children: ReactNode;
}) {
  return (
    <AuthUserContext.Provider value={user}>{children}</AuthUserContext.Provider>
  );
}

export function useAuthUser(): AppAuthUser {
  const ctx = useContext(AuthUserContext);
  if (!ctx) {
    throw new Error("useAuthUser must be used inside AuthUserProvider");
  }
  return ctx;
}
